import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getBetDetail=(id,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_BET_DETAIL_START,
    })
    const options={
        url:`${api}/bets/${id}`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_BET_DETAIL_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_BET_DETAIL_FAIL,
                payload:getMessage(error)
            }))
}